// extracted by mini-css-extract-plugin
module.exports = {"container":"quote_container__X8WAA","quote":"quote_quote__jYij5","rtl":"quote_rtl__0_xW3","quotee":"quote_quotee__5Zrfp","grid":"quote_grid__1nYh6"};